<template>
  <b-card class="mb-2">

    <!-- Encabezado -->
    <div class="d-flex align-items-center mb-2">
      <div class="stat-header-icon bg-light-info">
        <feather-icon
          icon="CreditCardIcon"
          size="20"
        />
      </div>

      <div class="ml-1">
        <h4 class="mb-25">
          Transacciones
        </h4>

        <small class="text-muted">
          Estado de las transacciones
        </small>
      </div>
    </div>

    <!-- Estadísticas -->
    <b-row>

      <b-col
        v-for="item in transactionStats"
        :key="item.key"
        cols="12"
        sm="6"
        md="4"
        lg="2"
      >
        <div class="transaction-stat">

          <!-- Icono -->
          <div
            class="transaction-icon"
            :class="item.bg"
          >
            <feather-icon
              :icon="item.icon"
              size="18"
            />
          </div>

          <!-- Información -->
          <div class="mt-50">

            <small class="d-block text-muted">
              {{ item.label }}
            </small>

            <h3
              class="mb-0"
              :class="item.text"
            >
              {{ formatNumber(datos[item.key]) }}
            </h3>

          </div>

        </div>
      </b-col>

    </b-row>

  </b-card>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
} from 'bootstrap-vue'

import { formatNumber } from '@core/utils/utils'

export default {
  name: 'CardTransacciones',

  components: {
    BCard,
    BRow,
    BCol,
  },

  props: {
    datos: {
      type: Object,
      required: true,
    },

    loader: {
      type: Boolean,
      default: false,
    },
  },

  setup() {
    const transactionStats = [
      {
        key: 'total_transacciones',
        label: 'Total',
        icon: 'LayersIcon',
        bg: 'bg-light-primary',
        text: 'text-primary',
      },
      {
        key: 'trans_pendientes',
        label: 'Pendientes',
        icon: 'ClockIcon',
        bg: 'bg-light-warning',
        text: 'text-warning',
      },
      {
        key: 'trans_autorizadas',
        label: 'Autorizadas',
        icon: 'CheckCircleIcon',
        bg: 'bg-light-success',
        text: 'text-success',
      },
      {
        key: 'trans_canceladas',
        label: 'Canceladas',
        icon: 'XCircleIcon',
        bg: 'bg-light-danger',
        text: 'text-danger',
      },
      {
        key: 'trans_completas',
        label: 'Completas',
        icon: 'CheckSquareIcon',
        bg: 'bg-light-info',
        text: 'text-info',
      },
      {
        key: 'trans_con_factura',
        label: 'Con factura',
        icon: 'FileTextIcon',
        bg: 'bg-light-secondary',
        text: 'text-secondary',
      },
    ]

    return {
      transactionStats,
      formatNumber,
    }
  },
}
</script>

<style scoped>
.stat-header-icon {
  width: 42px;
  height: 42px;
  border-radius: 8px;

  display: flex;
  align-items: center;
  justify-content: center;
}

.transaction-stat {
  text-align: center;
  padding: 10px 5px;
}

.transaction-icon {
  width: 40px;
  height: 40px;

  margin: 0 auto;

  border-radius: 50%;

  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
